import { useCallback } from 'react';
import { OperationVariables } from '@apollo/client';
import { MutationTuple } from '@apollo/client';
import { IntlShape } from 'react-intl';
import RedditPixel from 'react-reddit-pixel';

import google from 'app/lib/google';
import { CreateCustomerLeadApiResponse } from 'app/shared/graphql/customerLeads/mutationHooks';

export function useCreateCustomerLead() {
  const handleSubmit = useCallback(
    ({
      values,
      setSubmitting,
      setStatus,
      intl,
      createCustomerLead,
    }: {
      values: any;
      setSubmitting: (isSubmitting: boolean) => void;
      setStatus: (status: object) => void;
      intl: IntlShape;
      implementLeadGenOfferTest?: boolean;
      createCustomerLead: MutationTuple<
        CreateCustomerLeadApiResponse,
        OperationVariables
      >[0];
    }) => {
      google.dataLayer({
        event: 'newsletter_signup',
        email: values.email,
        newsletterSignup: {
          email: values.email,
          city: values.city,
        },
      });
      RedditPixel.init('a2_ekhq3a2jqrod');
      RedditPixel.track('Lead');
      createCustomerLead({
        variables: {
          email: values.email,
          cityId: values.city?.id,
          sourceUrl: window.location.href,
        },
      })
        .then(() => {
          setStatus({ success: true });
          setSubmitting(false);
        })
        .catch(() => {
          setStatus({
            success: false,
            error: intl.formatMessage({
              id: 'newsletter.form.error',
            }),
          });
          setSubmitting(false);
        });
    },
    []
  );
  return { handleSubmit };
}
